/*
  MacShack product page extras (sections/ms-main-product.liquid).
  - Help links (student offer, collect in store, returns) open a sheet instead of leaving the page.
  - Payment-partner links open in a new tab.
  - On phones, the condition-grade row starts at the grade of this unit.
*/
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* Anchors that open a sheet keep their href for no-JS; ms-product.js opens the sheet, this stops the page change. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-sheet-open]');
    if (!a) return;
    var dlg = document.getElementById(a.getAttribute('data-sheet-open'));
    if (dlg && dlg.showModal) e.preventDefault();
  }, true);

  function startGrades() {
    document.querySelectorAll('.ms-product .msp-grades').forEach(function (row) {
      var cur = row.querySelector('.msp-gc.is-current');
      if (row.scrollWidth > row.clientWidth + 2) {
        row.setAttribute('tabindex', '0');
        row.setAttribute('role', 'region');
        row.setAttribute('aria-label', 'Condition grades');
      }
      if (!cur || row.scrollWidth <= row.clientWidth + 2) return;
      var pad = parseFloat(getComputedStyle(row).paddingLeft) || 0;
      var left = cur.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft - pad;
      var prev = row.style.scrollBehavior;
      row.style.scrollBehavior = 'auto';
      row.scrollLeft = Math.max(0, left);
      row.style.scrollBehavior = prev;
    });
  }

  ready(function () {
    startGrades();
    /* Layout can shift once fonts and images load; settle the grade row again. */
    window.addEventListener('load', startGrades, { once: true });
  });
})();
